<template>
  <a-tabs class="ipc-group-wrap" @change="handlerTabChange">
    <a-tab-pane v-for="item in tabsList" :key="item.value" :tab="item.label">
        <PureCheckBox :instance="instance" v-on="$listeners"></PureCheckBox>
      </a-tab-pane>
  </a-tabs>
</template>

<script>
import PureCheckBox from './pureCheckBox.vue'

export default {
  props: {
    instance: Object
  },
  data() {
    return {
      tabsList: [] // list
    }
  },
  components: {
    PureCheckBox
  },
  created() {
    Object.assign(this, { ...this.instance })
  },
  methods: {
    // 处理ipc的参数
    handlerIpcParams() {
      // console.log(this.instance)
    },
    handlerTabChange(tab) {
      this.$emit('ipcTabChange', { tab, item: this.instance })
      this.$emit('clearSelected', this.instance.name) // 删除checkGroup的勾选缓存
    }
  }
}
</script>
